import { Checkbox, FormControlLabel, TextField } from "@material-ui/core";
import SingleSelectField from "@saleor/components/SingleSelectField";
import { TOperation } from "@saleor/discounts/hooks/useVoucherLimitsData";
import React, { FC, useMemo } from "react";
import { useIntl } from "react-intl";

import { CONDITIONS_CHOICES, generateMinNumberProps } from "./constants";
import { useStyles } from "./styles";

interface ICustomerActivitySubfieldProps {
  checkBoxLabel: string;
  textFieldLabel: string;
  isDisabled: boolean;
  checkboxValue: boolean;
  onToggleCheckbox: () => void;
  condition: TOperation;
  setCondition: (value: TOperation) => void;
  numberValue: number;
  setNumberValue: (value: number) => void;
}

const CustomerActivitySubfield: FC<ICustomerActivitySubfieldProps> = ({
  checkBoxLabel,
  textFieldLabel,
  isDisabled,
  checkboxValue,
  onToggleCheckbox,
  condition,
  setCondition,
  numberValue,
  setNumberValue
}) => {
  const intl = useIntl();
  const classes = useStyles({});

  const handleConditionSelectChange = event => {
    setCondition(event.target.value as TOperation);
  };

  const handleNumberValueChange = event => {
    if (
      /^[0-9\b]+$/.test(event.target.value) &&
      /^\d*$/.test(event.target.value)
    ) {
      setNumberValue(event.target.value);
    } else if (event.target.value === "") {
      setNumberValue(0);
    }
  };

  const handleNumberOnKeyDown = event => {
    if (event.key === "." || event.key === "-") {
      event.preventDefault();
    }
  };

  const conditionInputProps = useMemo(() => generateMinNumberProps(condition), [
    condition
  ]);

  return (
    <div className={classes.styledContainer}>
      <FormControlLabel
        control={
          <Checkbox checked={checkboxValue} onChange={onToggleCheckbox} />
        }
        label={checkBoxLabel}
        labelPlacement="end"
        disabled={isDisabled}
      />
      {checkboxValue && (
        <div className={classes.textFieldsContainer}>
          <SingleSelectField
            choices={CONDITIONS_CHOICES}
            value={condition}
            onChange={handleConditionSelectChange}
            label={intl.formatMessage({
              defaultMessage: "Condition"
            })}
            disabled={isDisabled}
            lowerDropdown
          />
          <TextField
            disabled={isDisabled}
            type="number"
            label={textFieldLabel}
            value={numberValue}
            onChange={handleNumberValueChange}
            fullWidth
            inputProps={conditionInputProps}
            onKeyDown={handleNumberOnKeyDown}
          />
        </div>
      )}
    </div>
  );
};

export default CustomerActivitySubfield;
